import { render, staticRenderFns } from "./ExpressOrderEditUser.vue?vue&type=template&id=59befa7e&scoped=true"
import script from "./ExpressOrderEditUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderEditUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59befa7e",
  null
  
)

export default component.exports